import type { tedsSandboxPageAPIInterface } from "@dealer-center/ddc-pages-teds-sandbox-page-interface";
import { useQuery } from "@tanstack/react-query";
export interface tedsSandboxPageFetchInterface {
  name: string;
  phone: string;
}

const queryKeyBase = "ddc-pages-user-search";

export function useTedsSandboxPageGet({
  name,
  phone
}: tedsSandboxPageFetchInterface) {
  return useQuery({
    queryKey: [queryKeyBase, { name, phone }],
    queryFn: () =>
      fetchTedsSandboxPage(name?.trim() || "", phone?.trim() || ""),
    enabled:
      !!name && name.trim().length > 0 && !!phone && phone.trim().length > 0
  });
}

const fetchTedsSandboxPage = (
  name: string,
  phone: string
): Promise<tedsSandboxPageAPIInterface> => {
  return fetch("/landing/nxlambda/tedsSandboxPage/" + name + "/" + phone).then(
    res => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error(res.statusText);
      }
    }
  );
};
